const INPUT_ELEMENT = {
    inputClassName: 'js-m-input',
    className: 'not-empty',
};

/**
 * добавление/удаление класса
 * @param elem {HTMLElement} - input
 * @param elem.value {String} - значение input
 */
function toggleClass(elem) {
    if (elem.value) {
        elem.classList.add(INPUT_ELEMENT.className);
    } else {
        elem.classList.remove(INPUT_ELEMENT.className);
    }
}

export default function stylizationInput() {
    const input = document.getElementsByClassName(INPUT_ELEMENT.inputClassName);

    for (let i = 0; i < input.length; i++) {
        toggleClass(input[i]);
        // eslint-disable-next-line func-names
        input[i].onblur = function () { toggleClass(input[i]); };
    }
}
